import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { authApi } from '../api';

export function RequirePermission({
  permission,
  children,
}: {
  permission?: string;
  children: ReactNode;
}) {
  const meQ = useQuery({ queryKey: ['admin-me'], queryFn: () => authApi.me() });
  if (!permission) return children;
  if (meQ.isLoading) return <div className="br-empty"><div className="br-empty__body">Loading…</div></div>;
  if (!meQ.data?.permissions.includes(permission)) {
    return <Navigate to="/" replace />;
  }
  return children;
}
